import { XCircle } from "lucide-react"; // Importing icons from Lucide
import React, { FC, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { resetPassword } from "../Utils/api";
import { SpinnerBorder } from "./Spinner/Spinner";
// import style from "./Spinner/Spinner.module.css";

interface PwResetProps {
  closeModal: () => void;
}

// const Spinner = () => (
//   <div className={style.spinner}>
//     {/* <div className={style.double_bounce1}></div> */}
//     {/* <div className={style.double_bounce2}></div> */}
//   </div>
// );

const PwReset: FC<PwResetProps> = ({ closeModal }) => {
  const [userName, setUserName] = useState("");
  const handleUserChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserName(e.target.value);
  };

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    if (userName.length > 0) {
      const errorMessage = await resetPassword(userName);
      if (errorMessage) {
        toast.error("Fehler: " + errorMessage);
      } else {
        toast.success("Anfrage erfolgreich versendet.");
      }
    } else {
      toast.error("Bitte gültigen Nutzernamen eingegeben.");
    }
    setLoading(false);
  };

  return (
    <div className="pw-reset-container bg-grey_lines p-4 rounded-lg w-[60%] select-none">
      <ToastContainer />

      <div className="form-group mb-4">
        <div className="flex justify-between">
          <label htmlFor="newPassword" className="block mb-2 text-gray-500">
            Bitte Nutzername eingeben
          </label>
          <button
            type="button"
            className="pb-4"
            onClick={() => {
              closeModal();
            }}
          >
            <XCircle size={24}></XCircle>
          </button>
        </div>

        <div className="flex items-center">
          <input
            type="text"
            id="user"
            value={userName}
            onChange={handleUserChange}
            required
            className="password-input flex-1 p-2 border rounded-l-lg border-gray-300 select-none"
          />
        </div>
      </div>

      <div className="flex justify-center">
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="flex justify-center items-center submit-button bg-blue-500 hover:bg-blue-700 text-white p-2 rounded-lg mx-auto w-1/3 select-none"
        >
          {loading ? <SpinnerBorder /> : "Neues Passwort beantragen"}
        </button>
      </div>
    </div>
  );
};

export default PwReset;
